import {FieldDescriptor} from "../../common/FormField";
import {useGetNodiByCodProg} from "../gestversore/Services";
import * as Yup from "yup";
import {useGetProgettiPianAtt, validationSchemaPianAtt} from "./Services";
import {useGetDipendentiProg} from "../../common/Services";



export  type PianAttForm = Yup.InferType<typeof validationSchemaPianAtt>
export const useFieldsAddPianAtt1 = (canEdit: boolean): FieldDescriptor<PianAttForm>[] => ([
  { name: "datainiziopian", label: "Data Inizio Pian.", type: "date", boxSize: "15%",disabled: !canEdit },
  { name: "datafinepian", label: "Data Fine Pian.", type: "date", boxSize: "15%",disabled: !canEdit },
  { name: "orepian", label: "Ore Pian.", type: "number", boxSize: "10%",disabled: !canEdit },
  {
      name: "minpian",
      label: "Min Pian.",
      type: "autocomplete",
      boxSize: "10%",
      options: [
          { label: '0', value: 0 },
          { label: '15', value: 15 },
          { label: '30', value: 30 },
          { label: '45', value: 45 },
      ],
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: !canEdit
    },
  { name: "orainiz", label: "Ora Inizio", type: "number", boxSize: "10%", disabled: !canEdit },
  { name: "mininiz", label: "Min Inizio", type: "number", boxSize: "10%", disabled: !canEdit },
  { name: "orafine", label: "Ora Fine", type: "number", boxSize: "10%", disabled: !canEdit },
  { name: "minfine", label: "Min Fine", type: "number", boxSize: "10%", disabled: !canEdit },
  // { name: "datainizioeff", label: "Data Inizio Eff.", type: "date", boxSize: "20%", disabled: !canEdit },
  // { name: "datafineeff", label: "Data Fine Eff.", type: "date", boxSize: "20%", disabled: !canEdit },
]);

export const useFieldsAddPianAtt2 = (codProg: string, filterProgs: string, canEdit: boolean,setValue: (name: keyof PianAttForm, value: any, options?: any) => void): FieldDescriptor<PianAttForm>[] => {
    const { data: ProgettiApiResponse } = useGetProgettiPianAtt(filterProgs);
    const { data: NodiApiResponse } = useGetNodiByCodProg(codProg || "");

  return  [
  // { name: "idcli", label: "Cliente", type: "autocomplete", boxSize: "25%", optionLabelKey: "label", optionValueKey: "idcli" },
      {
          name: "codprog",
          label: "Progetto*",
          type: "autocomplete",
          boxSize: "40%",
          options: () => ProgettiApiResponse?.results ?? [],
          optionLabelKey: "desprog",
          optionValueKey: "codprog",
          onChange: (_: any, codprog: string) => {
              if (!codprog) {
                  setValue("ref", "NN", {shouldValidate: true});
                  return;
              }
              const project = ProgettiApiResponse?.results?.find(
                  (p: any) => p.codprog === codprog
              );
              const refValue = project?.ref ?? "NN";
              setValue("ref", refValue, {shouldValidate: true});
          },
          disabled:  !canEdit,
      },
      {
      name: "codnodo",
      label: "Nodo*",
      type: "autocomplete",
      boxSize: "40%",
      options: () => NodiApiResponse?.results ?? [],
      optionLabelKey: "desnodo",
      optionValueKey: "codnodo",
      disabled: !codProg || !canEdit, // 👈 disattiva se non è selezionata il progetto

    },
    {
      name: "ref",
      label: "Referente",
      boxSize: "10%",
      type: "string",        // 👈 plain text
      disabled: true,        // 👈 read-only
    },

]
};

export const useFieldsAddPianAtt3 = ( canEdit: boolean): FieldDescriptor<PianAttForm>[] => {

  return  [
     { name: "percomp", label: "%Comp", type: "number", boxSize: "10%", disabled: !canEdit },

]
};

// export const useFieldsAddPianAtt4 = (
//   codProg: string,
//   canEdit: boolean
// ): FieldDescriptor<PianAttForm>[] => {
// // export const useFieldsAddPianAtt4 = ( canEdit: boolean): FieldDescriptor<PianAttForm>[] => {
//     const {  data: DipendentiApiResponse } = useGetDipendenti(2,"");
//  return   [
//      {
//   name: "coddip",
//   label: "Risorsa*",
//   boxSize: "50%",
//   type: "autocomplete",
//    disabled: !canEdit,
//   options: () => {
//     // console.log("Autocomplete options:", DipendentiApiResponse?.results);
//     return DipendentiApiResponse?.results ?? [];
//   },
//   optionLabelKey: "label",
//   optionValueKey: "coddip"
// },
//
//           ]
// };

export const useFieldsAddPianAtt4 = (
  codProg: string,
  canEdit: boolean
): FieldDescriptor<PianAttForm>[] => {
  const { data: DipendentiApiResponse } = useGetDipendentiProg(2, "");

  return [
    {
      name: "coddip",
      label: "Risorse*",
      boxSize: "50%",
      type: "autocomplete",
      disabled: !canEdit,
      options: () => {
        return DipendentiApiResponse?.results ?? [];
      },
      optionLabelKey: "label",
      optionValueKey: "coddip",
    },
  ];
};





export const useFieldsAddPianAtt5 = ( canEdit: boolean): FieldDescriptor<PianAttForm>[] => ([

  { name: "note", label: "Note", type: "textarea", boxSize: "50%", rows: 3, multiline: true, disabled: !canEdit },
]);
